<!-- eslint-disable -->
<template>
  <div id="onlinestate">
    <div class="row align-items-start pb-2">
      <div class="col-2">
        <button
          type="button"
          @click.prevent="onButtonOnlineClick"
          class="btn btn-outline-primary"
        >
          Dokument aktualisieren
        </button>
      </div>  
      <div class="col-10"></div>       
    </div>
    <div class="row align-items-start pb-2">
      <div clas="col-12">
        <Grid
          ref="grid"
          :style="{ height: '540px' }"
          :data-items="filteredData"
          :columns="columns"
          :filterable="true"
          :filter="filter"
          :sortable="true"
          :sort="sort"
          @filterchange="filterChange"
          @sortchange="sortChange"
          :filter-cell-render="filterRender"
          @custom="customHandler"
        >
          <template v-slot:myTemplate="{ props }">
            <document-link-container :data-item="props.dataItem" />
          </template>
          <template v-slot:filterSlotTemplate="{ props, methods }">
            <div>
              <input
                type="text"
                :value="props.value"
                @input="
                  (ev) => {
                    props.onChange({
                      operator: 'contains',
                      field: props.field,
                      value: ev.target.value,
                      syntheticEvent: ev,
                    });
                  }
                "
                style="width: 120px"
              />
              <button
                @click="
                  (ev) => {
                    props.onChange({
                      operator: '',
                      field: '',
                      value: '',
                      event: ev,
                    });
                  }
                "
              >
                Clear
              </button>
            </div>
          </template>
        </Grid>
      </div>
    </div>
  </div>
</template>

<script>
import { Grid } from "@progress/kendo-vue-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { apiPost } from "@/services/api/fetchapi";
import DocumentLinkContainer from "@/components/ControlCenter/DocumentLinkContainer";
 
export default {
  name: "DeviceOnlineState",
  inheritAttrs: false,
  components: {
    Grid,
    DocumentLinkContainer
  },
  data: function () {
    return {
      timerId: {},
      isSyncStarted: false,
      isSyncInProgress: false,
      filter: {},
      filteredData: [],
      originData: [],
      staticColumns: [
        {
          field: "idDocument",
          title: "idDocument",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "bereichName",
          title: "Bereich",
          filterCell: "filterSlotTemplate",
          width: "280px",
        },
        {
          field: "documentName",
          title: "Dokument",
          filterCell: "filterSlotTemplate",
          width: "280px",
        },
        {
          field: "documentUrl",
          title: "Link",
          filterable: false,
          sortable: false,
          width: "80px",
          cell: "myTemplate",
        },
      ],
    };
  },
  computed: {
    columns() {
      return [...this.staticColumns];
    },
  },
  methods: {
    onButtonOnlineClick() {
      this.getData();
    },
    filterChange: function (ev) {
      this.filter = ev.filter;
      this.filteredData = filterBy(this.originData, this.filter);
    },
    filterRender: function (h, defaultRendering, props, change) {
      return defaultRendering;
    },
    sortChange: function (e) {
      this.sort = e.sort;
      this.filteredData = orderBy(this.originData, this.sort);
    },
    getAreas() {
      const areaInfo = this.$store.getters["areastore/getDataSet"];
      const areas = [];
      for (let i = 0; i < areaInfo.areas.length; i++) {
        areas.push(areaInfo.areas[i]["idBereich"]);
      }
      return areas
    },   
    async getData() {
      const temp = await apiPost("ComponentView/viewDocumentLinks", {
        userId: this.$store.getters["userstore/getUser"],
        bereiche: this.getAreas(),
      });
      this.filteredData = temp.map((item) => {
        return { ...item };
      });
      this.originData = temp.map((item) => {
        return { ...item };
      });
    },
    async refreshData() {
      this.isSyncInProgress = true
      const temp = await apiPost("ComponentView/viewDocumentLinks", {
        userId: this.$store.getters["userstore/getUser"],
        bereiche: this.getAreas(),
      });
    },
    customHandler: function (e) {
      console.log("customHandler", e);
    },
  },
};
</script>

<style scoped language="scss">
.k-grid {
  font-size: 12px !important;
}
</style>